import React, { useState, useEffect } from 'react'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { Form, Button, Container, Row, Col, Card, Alert } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import Message from '../components/Message'
import Loader from '../components/Loader'
import { inventoryDetail, updateInventory } from '../actions/inventoryActions'
import { INVENTORY_UPDATE_RESET } from '../constants/inventoryConstants'
import { getItems } from '../actions/itemActions'
import { getAllnames } from '../actions/nameActions'

const InventoryUpdate = () => {
  const { id } = useParams()

  const [upc, setUpc] = useState('')
  const [manufacturers, setName] = useState('')
  const [subname, setSubname] = useState('')
  const [item, setItem] = useState('')
  const [qtyChange, setQtyChange] = useState(0)
  const [note, setNote] = useState('')
  const [lowinventory, setLowinventory] = useState('')
  const [cost, setCost] = useState('')
  const [price, setPrice] = useState('')
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    variant: 'success'
  })
  const [onetimeload, setOnetimeLoad] = useState(true)

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const returnTo = location.state?.from || '/inventory'

  const inventoryDetails = useSelector((state) => state.inventoryDetails)
  const { loading, success, unit } = inventoryDetails

  const inventoryUpdate = useSelector((state) => state.inventoryUpdate)
  const {
    loading: loadingUpdate,
    error: errorUpdate,
    success: successUpdate
  } = inventoryUpdate

  const itemList = useSelector((state) => state.itemList)
  const { items } = itemList

  const nameAll = useSelector((state) => state.nameAll)
  const { manufacturer } = nameAll

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  const ownerLogin = useSelector((state) => state.ownerLogin)
  const { ownerInfo } = ownerLogin

  const isAuthenticated = Boolean(ownerInfo || userInfo)

  useEffect(() => {
    if (!userInfo && !ownerInfo) {
      navigate('/login')
    } else if (successUpdate) {
      dispatch({ type: INVENTORY_UPDATE_RESET })
      navigate(returnTo)
    } else {
      dispatch(inventoryDetail(id))
      dispatch(getItems())
      dispatch(getAllnames())
    }
  }, [
    dispatch,
    id,
    successUpdate,
    navigate,
    returnTo,
    userInfo,
    ownerInfo,
    isAuthenticated
  ])

  useEffect(() => {
    if (unit && success) {
      setUpc(unit.upc)
      setName(unit.manufacturer)
      setSubname(unit.subname)
      setItem(unit.item)
      setLowinventory(unit.lowinventory)
      setCost(unit.cost)
      setPrice(unit.price)
      setOnetimeLoad(false)
    }
  }, [unit, onetimeload, success])

  const itemlist = Object.keys(items).map((key) => {
    return (
      <option key={key} value={items[key].item}>
        {items[key].item}
      </option>
    )
  }, this)

  const nameslist = Object.keys(manufacturer).map((key) => {
    return (
      <option key={key} value={manufacturer[key].manufacturer}>
        {manufacturer[key].manufacturer}
      </option>
    )
  }, this)

  // Show alert
  function showAlert(message, variant = 'success', seconds = 3000) {
    setAlert({
      show: true,
      message,
      variant
    })

    setTimeout(() => {
      setAlert({
        show: false,
        message: '',
        variant: 'success'
      })
    }, seconds)
  }

  // Submit handler
  const onSubmit = (e) => {
    e.preventDefault()

    const change = Number(qtyChange) || 0
    if (!Number.isInteger(change)) {
      showAlert('Quantity change must be a whole number', 'danger')
      return
    }

    if (window.confirm('Are you sure?')) {
      dispatch(
        updateInventory({
          _id: id,
          upc,
          manufacturer: manufacturers,
          subname,
          item,
          qtyChange: change,
          note,
          lowinventory,
          cost,
          price
        })
      )
      dispatch({ type: INVENTORY_UPDATE_RESET })
      showAlert('Inventory Updated', 'success')
    }
  }

  return (
    <Container>
      {alert.show && <Alert variant={alert.variant}>{alert.message}</Alert>}
      {loading && <Loader />}
      {loadingUpdate && <Loader />}
      {errorUpdate && <Message variant='danger'>{errorUpdate}</Message>}
      <Row className='my-3'>
        <Col>
          <Link
            to={returnTo}
            className='btn btn-outline-secondary btn-sm my-2 inventory-action-btn'
          >
            Go Back
          </Link>
        </Col>
      </Row>

      <h4>Edit Inventory Entry</h4>

      <Card className='mt-3 mb-3'>
        <Card.Body>
          <Form onSubmit={onSubmit}>
            <Row className='my-3'>
              <Col>
                <Form.Group>
                  <Form.Label>UPC</Form.Label>
                  <Form.Control
                    placeholder='UPC'
                    value={upc}
                    onChange={(e) => setUpc(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>Item</Form.Label>
                  <Form.Control
                    as='select'
                    value={item}
                    onChange={(e) => setItem(e.target.value)}
                  >
                    {itemlist}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
            <Row className='my-3'>
              <Col>
                <Form.Group>
                  <Form.Label>Manufacturer</Form.Label>
                  <Form.Control
                    as='select'
                    value={manufacturers}
                    onChange={(e) => setName(e.target.value)}
                  >
                    {nameslist}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>Subname</Form.Label>
                  <Form.Control
                    type='text'
                    placeholder='Subname'
                    value={subname}
                    onChange={(e) => setSubname(e.target.value)}
                  ></Form.Control>
                </Form.Group>
              </Col>
            </Row>
            <Row className='my-3'>
              <Col>
                <Form.Group>
                  <Form.Label>
                    Quantity on hand: {unit.qty}. Add (or remove with a minus):
                  </Form.Label>
                  <Form.Control
                    type='number'
                    step='1'
                    placeholder='0'
                    value={qtyChange}
                    onChange={(e) => setQtyChange(e.target.value)}
                  />
                  <Form.Control
                    type='text'
                    maxLength={200}
                    className='mt-2'
                    placeholder='Reason (optional), e.g. recount, damaged'
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label htmlFor='price'>Low Inventory Level</Form.Label>
                  <Form.Control
                    type='number'
                    className='w-25'
                    min='0'
                    step='1'
                    placeholder='0'
                    value={lowinventory}
                    onChange={(e) => setLowinventory(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className='my-3'>
              <Col>
                <Form.Group>
                  <Form.Label>Cost</Form.Label>
                  <Form.Control
                    type='number'
                    min='0.01'
                    step='0.01'
                    placeholder='Cost'
                    value={cost}
                    onChange={(e) => setCost(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>Price</Form.Label>
                  <Form.Control
                    type='number'
                    min='0.01'
                    step='0.01'
                    placeholder='Price'
                    value={price}
                    onChange={(e) => setPrice(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className='my-2'>
              <Col></Col>
            </Row>
            <Row className='my-3'>
              <Col>
                <Button
                  variant='outline-primary'
                  type='submit'
                  size='sm'
                  className='inventory-action-btn'
                >
                  Update
                </Button>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  )
}

export default InventoryUpdate
